"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColorIcon = exports.StyledTextColorIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
const maxHeight = 20;
exports.StyledTextColorIcon = styled_components_1.default.div `
  position: relative;
  max-height: ${rem(maxHeight)};

  &:after{
    content: '';
    display: block;
    background: ${({ colors }) => colors.length === 1
    ? colors[0]
    : `linear-gradient(to left, ${colors
        .map((color, index) => `${color} ${index * (100 / (colors.length - 1))}%`) // accordingly to the number of color elements, the percentage of each color will be calculated
        .join(', ')})`};
    ${({ theme }) => (0, styled_components_1.css) `
      max-height: ${rem(maxHeight)};
      width: 75%;
      height: ${rem(4)};
      border-radius: ${rem(theme.Border.Radius.Small)};
      position: absolute;
      top: ${rem(16)};
      right: ${rem(1)};
      border: ${rem(theme.Border.Size.Small)} solid
        ${theme.Color.Neutrals.Border};
    `}
  }
`;
function TextColorIcon({ colors }) {
    const theme = (0, ui_common_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(exports.StyledTextColorIcon, { colors: colors, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "text-color-alt---20", color: theme.Color.Neutrals.Dark }) }));
}
exports.TextColorIcon = TextColorIcon;
//# sourceMappingURL=index.js.map